export const Routing = {
	main: {
		base: '/',
	},
};
